/* eslint-disable import/prefer-default-export */
export function createClass(...args) {
    return args.filter((arg) => typeof arg === 'string' && arg !== '').join(' ');
}
